<template>
  <Modal v-model="visible" :title="formData.id ? '编辑' : '新增'" width="500" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form v-if="visible" ref="form" :model="formData" class="page-form" :label-width="75" v-loading="loading">
      <FormItem prop="img" label="图片" :rules="$units.formRule.required('请上传')" class="full">
        <uploadNew v-model="formData.imgUrl" @change="imgUpload" @remove="removeUploadImg" :disabled="formData.isSys == 1"></uploadNew>
        <span class="tips">建议最大不超过500KB，仅限上传jpg/jpeg/png格式；</span>
      </FormItem>

      <FormItem prop="systemType" label="平台" :rules="$units.formRule.required('请选择')" class="full">
        <RadioGroup v-model="formData.systemType" @on-change="selectSystem">
          <Radio label="1">iOS</Radio>
          <Radio label="2">Android</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem prop="imgSize" label="尺寸" :rules="$units.formRule.required('请选择')" class="full">
        <Select v-model="formData.imgSize" filterable transfer>
          <Option :value="item.value" v-for="(item, index) in sizeList" :key="index">{{ item.value }}</Option>
        </Select>
      </FormItem>

      <FormItem label="有效期" class="full">
        <DatePicker
          :clearable="true"
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          v-model="formData.validDate"
          format="yyyy-MM-dd"
          placeholder="不填立即生效"
        >
        </DatePicker>
      </FormItem>

      <FormItem prop="jumpType" label="跳转类型" :rules="$units.formRule.required('请选择')" class="full">
        <RadioGroup v-model="formData.jumpType" @on-change="changeJumpType">
          <Radio label="1">链接</Radio>
          <Radio label="2">产品</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        v-if="formData.jumpType == '1'"
        prop="url"
        label="链接地址"
        class="full"
        :rules="[$units.formRule.url(true), $units.formRule.required('请选择')]"
      >
        <Input v-model="formData.url" placeholder="链接必须以http://或https://开头" />
      </FormItem>
      <FormItem
        v-else
        prop="picTitle"
        label="产品名称"
        :rules="$units.formRule.required(formData.jumpType == '1' ? '请输入' : '请选择')"
        class="full"
        key="picTitle2"
      >
        <span class="product-title" v-if="formData.picTitle">{{ formData.picTitle }}</span>
        <Button type="primary" class="select-product-btn" @click="$refs.selectProduct.open()">{{ formData.picTitle ? '重新选择' : '选择产品' }}</Button>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save">确认</Button>
    </div>

    <!-- 选中产品 -->
    <select-product ref="selectProduct" @confirm-select="getSelectProduct"></select-product>
  </Modal>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
import selectProduct from './selectProduct';
import { filterTime } from '@/api/filter';

export default {
  components: { uploadNew, selectProduct },
  props: ['getTabList'],
  data() {
    return {
      tabId: '1',
      visible: false,
      loading: false,
      formData: {},
      sizeList: []
    };
  },
  methods: {
    async open(data = {}) {
      data = JSON.parse(JSON.stringify(data));
      if (data.id) {
        this.selectSystem(data.systemType);
        data.img = data.imgUrl.path;
        this.formData = data;
        this.formData.validDate = [data.effectTimeStart, data.effectTimeEnd];
        this.formData.productCode = data.productCode;
        this.formData.picTitle = data.productName;
      } else {
        this.formData = {
          jumpType: '1',
          imgUrl: []
        };
      }
      this.visible = true;
    },
    
    querySize(code) {
      this.$http({
        url: '/system/dic/read/dicList',
        type: 'POST',
        data: {
          code
        }
      }).then(res => {
        this.sizeList = res.data;
      });
    },

    selectSystem(value) {
      if (value == '1') {
        this.querySize('IOS_SIZE');
      } else {
        this.querySize('ANDROID_SIZE');
      }
    },

    // 上传图片
    imgUpload() {
      if (this.formData.imgUrl && this.formData.imgUrl[0]) {
        this.$set(this.formData, 'img', this.formData.imgUrl[0].path);
      }
      this.$refs.form.validateField('img');
    },

    // 删除图片
    removeUploadImg(index) {
      this.$set(this.formData, 'img', '');
    },

    // 切换调整类型
    changeJumpType(value) {
      if (value == '2') {
        // this.formData.picTitle = '';
        // this.formData.jumpUrl = '';
      } else {
        // this.formData.picTitle = '';
        // delete this.formData.productCode;
      }
    },

    // 选中产品
    getSelectProduct(data) {
      this.formData = {
        ...this.formData,
        productCode: data.productCode,
        picTitle: data.productName
      };
    },

    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        let data = {
          systemType: formData.systemType,
          jumpType: formData.jumpType,
          imgUrl: formData.img,
          url: formData.url,
          imgSize:formData.imgSize,
          effectTimeStart: formData.validDate && formData.validDate[0] ? filterTime(formData.validDate[0], 'YYYY-MM-DD HH:mm:ss') : '',
          effectTimeEnd: formData.validDate && formData.validDate[1] ? filterTime(formData.validDate[1], 'YYYY-MM-DD 23:59:59') : ''
        };
        delete formData.validDate;
        if (this.formData.id) {
          data.id = this.formData.id;
        }
        if (formData.jumpType == '2') {
          data.productCode = formData.productCode;
          data.productName = formData.picTitle;
        }
        this.$http({
          url: this.formData.id ? '/buz/personalizedconfig/advertisPageConfig/edit' : '/buz/personalizedconfig/advertisPageConfig/add',
          type: 'POST',
          data
        }).then(res => {
          this.visible = false;
          this.$notice.success(formData.id ? '修改成功' : '新增成功');
          this.getTabList();
        });
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.product-title {
  margin-right: 15px;
  font-size: 12px;
}
.select-product-btn {
  height: 25px;
  line-height: 25px;
  margin-top: 2px;
}
.tips {
  font-size: 12px;
  color: #a8a3a3;
}
</style>
